/* Module1.store.js */

import axios from 'axios';
import iliosState from '@/ilios.store';

const initialState = () => ({
  apiState: iliosState.INIT,
  immobilesList: [],
  immobilesImageList: [],
  buyMenuId: null,
  rentMenuId: null,
  immobileDetail: null,
  immobileDetailImages: null,
});

// State object
const state = {
  apiState: iliosState.INIT,
  immobilesList: [],
  immobilesImageList: [],
  buyMenuId: null,
  rentMenuId: null,
  immobileDetail: null,
  immobileDetailImages: null,
}

// Getter functions
const getters = {

  getApiState() {
    return state.apiState
  },

  getBuyMenuId(){
    return state.buyMenuId
  },

  getRentMenuId(){
    return state.rentMenuId
  },

  getImmobilesList(){
    return state.immobilesList
  },

  getImmobileDetail(){
    return state.immobileDetail
  },

  getimmobileDetailImages(){
    return state.immobileDetailImages
  },

  getImmobilesImageList(){
    return state.immobilesImageList
  }
};

// Actions
const actions = {

  async getImmobilesList(context, { domain }) {
    var result = null
    context.commit('SET_API_STATE', {
      apiState: iliosState.LOADING
    });
    await axios.get(process.env.VUE_APP_BASE_URL + '/iliosrest/get/imovel',
    {
      params: {
        fields: "['codigo_imovel', 'valor_c_doc', 'valor_aluguel', 'state', 'tipo_imovel', 'cidade', 'bairro', 'estado', 'finalidade_imovel', 'total_quartos', 'total_suites', 'vaga_garagem_coberta', 'vaga_garagem_descoberta', 'quantidade_banheiros', 'area_total']",
        domain: domain,
        context : {
          "lang": "pt_BR",
          "tz" : Intl.DateTimeFormat().resolvedOptions().timeZone
        },
      },
      headers: {
       'Content-Type' : 'form/x-www-form-urlencoded', 
       'charset' : 'utf-8',
       'Access-Token': process.env.VUE_APP_TOKEN
      }
    })
    .then(response => {
      if(response['status'] == 200) {
        result = response.data.data
        var immobilesImagesIds = []
        result.forEach(element => {
          immobilesImagesIds.push(element.id)
        })
        context.commit('SET_IMMOBILES_LIST', {
          immobilesList: response.data.data
        });
        context.dispatch('getImmobileImageList', {
          immobileIds: immobilesImagesIds,
        })
      }      
    })    
    .catch(e => {     
      context.commit('SET_API_STATE', {
        apiState: iliosState.LOADED
      }); 
      var messageError = e.response ? e.response.data.message : e
      console.log(messageError);
    })
    return result
  },

  async getImmobileDetail(context, { immobileId }) {
    var result = null
    context.commit('SET_API_STATE', {
      apiState: iliosState.LOADING
    });
    await axios.get(process.env.VUE_APP_BASE_URL + '/iliosrest/get/imovel',
    {
      params: {
        fields: "['latitude', 'logitude', 'share_link_maps', 'numero', 'rua', 'cep', 'codigo_imovel', 'valor_c_doc', 'valor_aluguel', 'state', 'tipo_imovel', 'cidade', 'bairro', 'estado', 'finalidade_imovel', 'total_quartos', 'total_suites', 'vaga_garagem_coberta', 'vaga_garagem_descoberta', 'quantidade_banheiros', 'area_total', 'observacoes', 'tipo_forro', 'academia', 'cerca_eletrica', 'portaria_24_horas', 'piscina', 'jardim_de_inverno', 'elevador', 'area_gourmet', 'sala_de_tv', 'sala_de_jantar', 'sala_de_estar', 'sacada', 'despensa', 'copa', 'closet', 'area_de_servico', 'posicao', 'area_privativa', 'metragem_construida', 'valor_medio_iptu']",
        domain: "[('id', '='," + immobileId + ")]",
        context : {
          "lang": "pt_BR",
          "tz" : Intl.DateTimeFormat().resolvedOptions().timeZone
        },
      },
      headers: {
       'Content-Type' : 'form/x-www-form-urlencoded', 
       'charset' : 'utf-8',
       'Access-Token': process.env.VUE_APP_TOKEN
      }
    })
    .then(response => {
      if(response['status'] == 200) {
        result = response.data.data[0]
        context.commit('SET_IMMOBILE_DETAIL', {
          immobileDetail: response.data.data[0]
        });
        context.dispatch('getImmobileImages', {
          immobileId: immobileId,
        })
      }      
    })    
    .catch(e => {     
      context.commit('SET_API_STATE', {
        apiState: iliosState.LOADED
      }); 
      var messageError = e.response ? e.response.data.message : e
      console.log(messageError);
    })
    return result
  },

  async getImmobileCustom(context, { domain, fields }) {
    var result = null
    context.commit('SET_API_STATE', {
      apiState: iliosState.LOADING
    });
    await axios.get(process.env.VUE_APP_BASE_URL + '/iliosrest/get/imovel',
    {
      params: {
        fields: fields,
        domain: domain,
        context : {
          "lang": "pt_BR",
          "tz" : Intl.DateTimeFormat().resolvedOptions().timeZone
        },
      },
      headers: {
       'Content-Type' : 'form/x-www-form-urlencoded', 
       'charset' : 'utf-8',
       'Access-Token': process.env.VUE_APP_TOKEN
      }
    })
    .then(response => {
      if(response['status'] == 200) {
        result = response.data.data
      }      
    })    
    .catch(e => {      
      var messageError = e.response ? e.response.data.message : e
      console.log(messageError);
    })
    context.commit('SET_API_STATE', {
      apiState: iliosState.LOADED
    });
    return result
  },

  async getImmobileImages(context, { immobileId }) {
    var result = null
    context.commit('SET_API_STATE', {
      apiState: iliosState.LOADING
    });
    await axios.get(process.env.VUE_APP_BASE_URL + '/iliosrest/get/ir.attachment',
    {
      params: {
        fields: "['id']",
        domain: "[('res_id', '='," + immobileId + "), ('res_model', '=', 'imovel' ), ('public', '=', 1 ), ('index_content', '=', 'image')]",
        context : {
          "lang": "pt_BR",
          "tz" : Intl.DateTimeFormat().resolvedOptions().timeZone
        },
      },
      headers: {
       'Content-Type' : 'form/x-www-form-urlencoded', 
       'charset' : 'utf-8',
       'Access-Token': process.env.VUE_APP_TOKEN
      }
    })
    .then(response => {
      if(response['status'] == 200) {
        result = response.data.data
        context.commit('SET_IMMOBILE_IMAGES', {
          immobileImages: response.data.data
        });
      }      
    })    
    .catch(e => {     
      context.commit('SET_API_STATE', {
        apiState: iliosState.LOADED
      }); 
      var messageError = e.response ? e.response.data.message : e
      console.log(messageError);
    })
    return result
  },

  async getImmobileImageList(context, { immobileIds }) {
    var result = null
    context.commit('SET_API_STATE', {
      apiState: iliosState.LOADING
    });
    await axios.get(process.env.VUE_APP_BASE_URL + '/iliosrest/get/ir.attachment',
    {
      params: {
        fields: "['id', 'res_id']",
        domain: "[('res_id', 'in',[" + immobileIds + "]), ('res_model', '=', 'imovel' ), ('public', '=', 1 ), ('index_content', '=', 'image')]",
        context : {
          "lang": "pt_BR",
          "tz" : Intl.DateTimeFormat().resolvedOptions().timeZone
        },
      },
      headers: {
       'Content-Type' : 'form/x-www-form-urlencoded', 
       'charset' : 'utf-8',
       'Access-Token': process.env.VUE_APP_TOKEN
      }
    })
    .then(response => {
      if(response['status'] == 200) {
        result = response.data.data
        context.commit('SET_IMMOBILE_IMAGE_LIST', {
          immobileImages: response.data.data
        });
      }      
    })    
    .catch(e => {     
      context.commit('SET_API_STATE', {
        apiState: iliosState.LOADED
      }); 
      var messageError = e.response ? e.response.data.message : e
      console.log(messageError);
    })
    return result
  },

  async postRegisterImmobile(context, { data }) {
    var result = null
    context.commit('SET_API_STATE', {
      apiState: iliosState.LOADING
    });
    await axios.post(process.env.VUE_APP_BASE_URL + '/iliosrest/post/crm.lead',
      {
        data :{
          "name": data.name,
          "planned_revenue": data.planned_revenue,
          "email_from": data.email_from,
          "phone": data.phone,
          "finalidade_imovel": data.finalidade_imovel,
          "partner_name": data.partner_name,
          "street": data.street,
          "street2": data.street2,
          "city": data.city,
          "state_char": data.state_char,
          "zip": data.zip,
          "state_id": data.state_id,
          "description": data.description,
          "recaptchaToken": data.recaptchaToken,
          context : {
            "lang": "pt_BR",
            "tz" : Intl.DateTimeFormat().resolvedOptions().timeZone
          },
        }
      },
      {
        headers: {
          'Content-Type' : 'form/x-www-form-urlencoded',
          'charset' : 'utf-8',
          'Access-Token': process.env.VUE_APP_TOKEN
        }
      }
    ).then(response => {
      if(response['status'] == 200) {
        result = response.data.data
        context.commit('SET_API_STATE', {
          apiState: iliosState.LOADED
        });
      }
    }).catch(e => {
      var messageError = e.response ? e.response.data.message : e
      console.log(messageError);
      context.commit('SET_API_STATE', {
        apiState: iliosState.LOADED
      });
    })
    return result
  },

  async setBuyMenuValue(context, {menuId} ){
    await context.commit('SET_BUY_MENU_VALUE', {menuId: menuId})
  },

  async setRentMenuValue(context, {menuId} ){
    await context.commit('SET_RENT_MENU_VALUE', {menuId: menuId})
  },

  async cleanImmobileList(context) {
    await context.commit("CLEAN_IMMOBILE_LIST")
  },

  async cleanBuyMenuId(context) {
    await context.commit("CLEAN_BUY_MENU_ID")
  },

  async cleanRentMenuId(context) {
    await context.commit("CLEAN_RENT_MENU_ID")
  },

  reset(context) {
    context.commit('RESET');
  },
};

// Mutations
const mutations = {
  SET_IMMOBILES_LIST(state, { immobilesList }) {
    state.immobilesList = immobilesList
    state.apiState = iliosState.LOADED
  },

  SET_IMMOBILE_DETAIL(state, { immobileDetail }) {
    state.immobileDetail = immobileDetail
    state.apiState = iliosState.LOADED
  },

  SET_IMMOBILE_IMAGES(state, { immobileImages }) {
    var srcList = []
    immobileImages.forEach(element => {
      srcList.push({id: element.id, url: process.env.VUE_APP_BASE_URL + '/web/image/' + element.id})
    })
    state.immobileDetailImages = srcList
    state.apiState = iliosState.LOADED
  },

  SET_IMMOBILE_IMAGE_LIST(state, { immobileImages }) {
    var srcList = []
    immobileImages.forEach(element => {
      srcList.push({id: element.id, url: process.env.VUE_APP_BASE_URL + '/web/image/' + element.id, res_id: element.res_id})
    })
    state.immobilesImageList = srcList
    state.apiState = iliosState.LOADED
  },

  SET_BUY_MENU_VALUE(state, { menuId }) {
    state.buyMenuId = menuId
  },

  SET_RENT_MENU_VALUE(state, { menuId }) {
    state.rentMenuId = menuId
  },

  CLEAN_IMMOBILE_LIST(state) {
    state.immobilesList = []
  },

  CLEAN_BUY_MENU_ID(state) {
    state.buyMenuId = null
  },

  CLEAN_RENT_MENU_ID(state) {
    state.rentMenuId = null
  },

  SET_API_STATE(state, { apiState }) {
    state.apiState = apiState
  },

  RESET(state) {
    const newState = initialState();
    Object.keys(newState).forEach((key) => {
      state[key] = newState[key];
    });
  },
};

export default {
  actions,
  state,
  getters,
  mutations,
  namespaced: true,
};